const {
  PhoneNumberFormat: PNF,
  PhoneNumberType,
  PhoneNumberUtil
} = require('google-libphonenumber');

const phoneUtil = PhoneNumberUtil.getInstance();

const MOBILE_PHONE_TYPES = new Set([
  PhoneNumberType.MOBILE,
  PhoneNumberType.FIXED_LINE_OR_MOBILE
]);

export const formatPhoneNumber = (number = '', countryCode = '') => {
  if (!countryCode || !number) return '';

  const numberUtil = phoneUtil.parseAndKeepRawInput(number, countryCode);
  const newNumber = phoneUtil.format(numberUtil, PNF.E164);
  return newNumber;
};

/**
 * @param {string} phone - E.164 or national number
 * @param {string} [countryCode] - ISO region (e.g. EC) when phone has no country prefix
 */
export const isValidMobilePhoneNumber = (phone, countryCode = '') => {
  const raw = String(phone || '').trim();
  if (!raw) return false;

  try {
    const parsed = raw.startsWith('+')
      ? phoneUtil.parse(raw)
      : phoneUtil.parse(raw, countryCode || undefined);

    if (!phoneUtil.isValidNumber(parsed)) return false;

    return MOBILE_PHONE_TYPES.has(phoneUtil.getNumberType(parsed));
  } catch {
    return false;
  }
};
